// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3ABw4","notes":"Notes_notes__1WqWq","note":"Notes_note__3TMGu","markdown":"Notes_markdown__RKM-z"};